import { ReactComponent as Fitness } from "@icons/fitness.svg";
import { ReactComponent as Meditation } from "@icons/meditation.svg";
import { ReactComponent as Recipes } from "@icons/recipes.svg";
import { ResourceTile } from "../ResourceTile";
import { WellKnownLearningMaterialSubCategories } from "UIPalette/LearningMaterials/wellKnownLearningMaterials";
import { t } from "i18next";
import { trackCardClicks } from "core/monitoring/Events";
import { useNavigate } from "react-router-dom";

export const WellbeingResourceTiles = () => {
  const navigate = useNavigate();

  const handleClickMeditation = () => {
    trackCardClicks("Meditation");
    navigate(`/audio-and-video/#si=${WellKnownLearningMaterialSubCategories.meditation}`, { state: { hideInterests: true } });
  };

  const handleClickRecipes = () => {
    trackCardClicks("Recipes");
    navigate(`/articles/#si=${WellKnownLearningMaterialSubCategories.recipes}`, { state: { hideInterests: true } });
  };

  const handleClickFitness = () => {
    trackCardClicks("Fitness");
    navigate(`/audio-and-video/#si=${WellKnownLearningMaterialSubCategories.fitness}`, {
      state: { hideInterests: true },
    });
  };

  return (
    <div className="flex flex-row justify-around w-full gap-2 h-fit md:gap-4">
      <ResourceTile
        title={t("resources.meditationLinkName")}
        ariaLabel={t("resources.meditationNavigationLabel")}
        ResourceIcon={Meditation}
        onClick={handleClickMeditation}
      />
      <ResourceTile
        title={t("resources.recipesLinkName")}
        ariaLabel={t("resources.recipesnNavigationLabel")}
        ResourceIcon={Recipes}
        onClick={handleClickRecipes}
      />
      <ResourceTile
        title={t("resources.fitnessLinkName")}
        ariaLabel={t("resources.fitnessNavigationLabel")}
        ResourceIcon={Fitness}
        onClick={handleClickFitness}
      />
    </div>
  );
};
